import { Component, Inject } from '@angular/core';
import { DIALOG_DATA, DialogRef } from '@angular/cdk/dialog';
import { DialogData } from '../../interfaces/dialog-data';

@Component({
    selector: 'app-are-you-sure2',
    templateUrl: './are-you-sure2.component.html',
    standalone: false
})
export class AreYouSure2Component {
    title: string = '';
    message: string = '';

    constructor(
        public dialogRef: DialogRef<DialogData>,
        @Inject(DIALOG_DATA) public data: DialogData,
    ) {
        this.title = data.title || "Warning";
        this.message = data.message || "This action cannot be reversed!";
    };
}
